// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__prldL","form-title":"Common_form-title__aTmfP","form-actions":"Common_form-actions__Xdw6F"};